import React from "react";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Collapse,
  Container,
  Row,
  Col,
} from "reactstrap";

function AccordionSolutions() {
  const [openedCollapse, setOpenedCollapse] = React.useState("collapse-1");
  return (
    <div className="accordion-1 bg-default">
      <Container>
        <Row>
          <Col className="ml-auto" md="12">
            <div className="accordion">
              <Card>
                <CardHeader id="intelligenceSolutions">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-1"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-1" ? "" : "collapse-1"
                        )
                      }
                      className="w-100 text-info font-weight-bolder text-left"
                      color="link"
                      type="button"
                    >
                      Intelligence Solutions{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-1"}>
                  <CardBody className="text-default">
                   Unlock the power of actionable intelligence with CrypTegridy. Our unique 
                   blend of human intelligence and advanced OSINT tools ensures that we spot 
                   nuanced data that others miss. Stay ahead of threats and make informed 
                   decisions with our expert insights. Contact us today to enhance your 
                   strategic planning and security measures!
                  </CardBody>
                </Collapse>
              </Card>
              <Card>
                <CardHeader id="assetTracing">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-2"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-2" ? "" : "collapse-2"
                        )
                      }
                      className="w-100 text-info font-weight-bolder text-left collapsed"
                      color="link"
                      type="button"
                    >
                      Asset Tracing and Recovery{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-2"}>
                  <CardBody className="text-default">
                   Recovering lost assets is complex and costly, but with CrypTegridy, you have 
                   the best in the business on your side. Our team combines human intelligence 
                   with cutting-edge forensic techniques to trace and recover crypto assets. 
                   While recovery is never guaranteed, our expertise maximizes your chances. 
                   Reach out now to start your asset recovery journey!
                  </CardBody>
                </Collapse>
              </Card>
              <Card>
                <CardHeader id="dueDiligence">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-3"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-3" ? "" : "collapse-3"
                        )
                      }
                      className="w-100 text-info font-weight-bolder text-left collapsed"
                      color="link"
                      type="button"
                    >
                      Due Diligence{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-3"}>
                  <CardBody className="text-default">
                  Ensure your investments and partnerships are secure with CrypTegridy. Our due 
                  diligence process leverages human intelligence to provide deep insights and 
                  thorough evaluations. From crypto asset assessments to corporate compliance, 
                  we help you navigate risks and make informed decisions. Contact us today to 
                  safeguard your business interests!
                  </CardBody>
                </Collapse>
              </Card>
              <Card>
                <CardHeader id="privateInvestigations">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-4"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-4" ? "" : "collapse-4"
                        )
                      }
                      className="w-100 text-info font-weight-bolder text-left"
                      color="link"
                      type="button"
                    >
                      Private Investigations{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-4"}>
                  <CardBody className="text-default">
                   Protect your privacy and security with CrypTegridy. Our private investigations 
                   utilize human intelligence to conduct thorough background checks, surveillance, 
                   and online activity monitoring. Whether you need to locate assets or individuals, 
                   our expert team provides comprehensive and actionable intelligence. Get in touch 
                   now to secure your peace of mind!
                  </CardBody>
                </Collapse>
              </Card>
              <Card>
                <CardHeader id="corporateInvestigations">
                  <h5 className="mb-0">
                    <Button
                      aria-expanded={openedCollapse === "collapse-5"}
                      onClick={() =>
                        setOpenedCollapse(
                          openedCollapse === "collapse-5" ? "" : "collapse-5"
                        )
                      }
                      className="w-100 text-info font-weight-bolder text-left"
                      color="link"
                      type="button"
                    >
                      Corporate Investigations{" "}
                      <i className="ni ni-bold-down float-right pt-1"></i>
                    </Button>
                  </h5>
                </CardHeader>
                <Collapse isOpen={openedCollapse === "collapse-5"}>
                  <CardBody className="text-default">
                    Safeguard your business with CrypTegridy. Our corporate investigations team excels in 
                    detecting fraud, financial discrepancies, and corporate espionage. By combining human 
                    intelligence with advanced forensic methods, we provide clear and actionable insights 
                    to protect your organization. Contact us today to maintain your corporate integrity 
                    and security!
                  </CardBody>
                </Collapse>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default AccordionSolutions;
